import CalendarToday from '@mui/icons-material/CalendarToday';
import { DateRange } from '@mui/x-date-pickers-pro';
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { dateText } from './DateFilterButton';

export interface DateFilterTextFieldProps {
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLInputElement | HTMLButtonElement | null>>;
  controllerName: string;
  inputText: string;
  handleReset: () => void;
  resetEnabled: boolean;
  dates?: DateRange<dayjs.Dayjs>;
  date?: dayjs.Dayjs | null;
  isComparison?: boolean;
  textFieldLabel?: string;
  isRequired?: boolean;
}

function DateFilterTextField({
  setAnchorEl,
  controllerName,
  inputText,
  handleReset,
  resetEnabled,
  dates,
  date,
  isComparison = false,
  textFieldLabel,
  isRequired,
}: Readonly<DateFilterTextFieldProps>) {
  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLInputElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <TextField
      fullWidth
      label={textFieldLabel}
      data-testid={`${controllerName}-date-filter-text-field`}
      variant='standard'
      onClick={handleClick}
      value={dateText(t, date, dates, isComparison, inputText)}
      required={isRequired}
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment
            position='end'
            sx={{
              '.reset-btn': {
                opacity: 0,
                pointerEvents: 'none',
                transition: 'opacity 0.15s',
              },
              '.MuiInputBase-root:hover & .reset-btn, .MuiInputBase-root:focus-within & .reset-btn': {
                opacity: 1,
                pointerEvents: 'auto',
              },
            }}
          >
            {resetEnabled && (
              <IconButton
                className='reset-btn'
                sx={{ width: 28, height: 28, marginRight: '-2px', padding: '4px' }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleReset();
                }}
              >
                <CloseOutlinedIcon sx={{ fontSize: '20px' }} />
              </IconButton>
            )}
            <IconButton sx={{ width: 28, height: 28 }}>
              <CalendarToday fontSize='inherit' />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

DateFilterTextField.defaultProps = {
  dates: undefined,
  date: null,
  isComparison: false,
  textFieldLabel: '',
  isRequired: false,
};

export default DateFilterTextField;
